// path: src/Components/AppFooter.js

import React from "react";
import { APP_FOOTER_LINE } from "../utils/appVersion";

/**
 * Shared version + copyright strip. Use inside BottomNav or as a
 * fixed footer on screens without the Material bottom bar.
 */
export default function AppFooter({
    className = "",
    variant = "bar",
    onPrivacyPolicy,
    onTermsOfService,
}) {
    const classes =
        variant === "overlay"
            ? `appFooter appFooter--overlay ${className}`.trim()
            : `appVersion ${className}`.trim();

    const hasLegalLinks =
        typeof onPrivacyPolicy === "function" ||
        typeof onTermsOfService === "function";

    return (
        <div className={classes}>
            <div className="appFooter__line">{APP_FOOTER_LINE}</div>
            {hasLegalLinks ? (
                <div className="appFooter__links">
                    {typeof onPrivacyPolicy === "function" ? (
                        <button
                            type="button"
                            className="appFooter__link"
                            onClick={onPrivacyPolicy}
                        >
                            Privacy Policy
                        </button>
                    ) : null}
                    {typeof onPrivacyPolicy === "function" &&
                    typeof onTermsOfService === "function" ? (
                        <span className="appFooter__sep" aria-hidden="true">
                            ·
                        </span>
                    ) : null}
                    {typeof onTermsOfService === "function" ? (
                        <button
                            type="button"
                            className="appFooter__link"
                            onClick={onTermsOfService}
                        >
                            Terms of Service
                        </button>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
